import wretch from 'wretch'
import { queryStringAddon } from 'wretch/addons'
import { dedupe } from 'wretch/middlewares'

import { autoAuthorization } from '~in-app/lib/wretch/middewares/auto-authorization'

import abortAddon from './addons/abort'
import { autoSignOut } from './middewares/auto-sign-out'

export const wretchClient = wretch(import.meta.env.VITE_API_URL)
  .addon(abortAddon())
  .addon(queryStringAddon)
  .middlewares([
    autoAuthorization(),
    dedupe(),
    autoSignOut(),
  ])
